import { render, staticRenderFns } from "./LabelPrintingPage.vue?vue&type=template&id=0f45dc14&scoped=true&"
import script from "./LabelPrintingPage.vue?vue&type=script&lang=js&"
export * from "./LabelPrintingPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f45dc14",
  null
  
)

export default component.exports